import { useRef } from "react";
import type { EvalBidDto } from "../../../autogen/bff-api";

// buildEvaluationDto sorts bids by rank, so every saved score can come back in a different order.
export const useStableBidOrder = (bids: EvalBidDto[]): EvalBidDto[] => {
  const seen = useRef<string[]>([]);

  for (const { bidId } of bids) {
    if (!seen.current.includes(bidId)) seen.current.push(bidId);
  }

  const position = new Map(seen.current.map((bidId, index) => [bidId, index]));
  return [...bids].sort(
    (a, b) => (position.get(a.bidId) ?? 0) - (position.get(b.bidId) ?? 0),
  );
};
